import React, { useState, useEffect, useContext } from "react";
import "./deliveryInfoModal.scss";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import Backdrop from "@mui/material/Backdrop";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import LoaderAnimation from "../LoaderAnimation";
// Context api calling
import StateContext from "../../StateContext";
import Avatar from "@mui/material/Avatar";
import Armada from "./component/armada";
import Wiyak from "./component/wiyak";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const DeliveryInfoModal = (props) => {
  const { t } = useTranslation();
  const { invoiceable, open, setOpen} =props;
  const appState = useContext(StateContext);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [open]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <LoaderAnimation />
        </Backdrop>
      )}

      <div
        id="mySidenav"
        className={` px-3 deliveryInfoModal   ${
          appState.langValue == "ar" ? "" : " "
        }`}
      >
        <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">
          &times;
        </a>
        {invoiceable?.integration?.integration?.type?.name == 'WIYAK' ?  <Wiyak props={props} loading={loading} />  : <Armada  props={props} loading={loading}  /> }
        
        
      </div>
    </>
  );
};

export default withTranslation()(DeliveryInfoModal);
